// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DQyqvwDnrY8AY34j0VtO {
    width: 42px;
    height: 42px;
    border-radius: 42px;
    object-fit: cover;
}

.iVJP_pBDy9Bpboeg7811 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 16px;
}

.TJm8QjsyxHIXzz_Y8vRV {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    transition: .3s;
}

.TJm8QjsyxHIXzz_Y8vRV:hover {
    color: rgba(0,0,0,0.8);
}

.WV7jsdjR_d7AGX7fvg3s {
    width: 100%;
    min-height: 32px;

    display: flex;
    align-items: center;

    border: 1px solid #E5E5E5;
    border-radius: 5px;

    margin-top: 8px;
    padding-left: 4px;
}

.WV7jsdjR_d7AGX7fvg3s:hover {
    border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.WV7jsdjR_d7AGX7fvg3s input {
    width: 90%;
    height: 100%;
    border: none;
    outline: none;
}

.SB1pKVYF7kUthf9JTZhN {
    display: flex;
    align-items: center;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    font-size: 14px;
    transition: .3s;
}

.SB1pKVYF7kUthf9JTZhN:hover {
    color: rgba(0,0,0,0.8);
}

.pcKaQJnYbDUccGU6zM3M {
    font-size: 18px;
    margin: 0;
}

.DHIhkkHQXI5cY7kP28v9 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    height: 64px;
    padding: 0 16px;

    transition: .3s;
}

.DHIhkkHQXI5cY7kP28v9:hover {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]};
    cursor: pointer;
}

.qGJ9SxjDNgQXOc4NmZ9F, .XaDIGlNhQuyV_TpQeNPm {
    margin: 0;
    text-align: right;
}

.qGJ9SxjDNgQXOc4NmZ9F { font-weight: 500; }
.XaDIGlNhQuyV_TpQeNPm { color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}; }

.pgKU6qGd9K_MAs0uwbcd {
    font-size: 18px;
    font-weight: 500;
    padding: 0 16px;
    text-align: center;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
}

.hSicMw3qjMrp_JTtKgET {
    font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardWallet/DashboardWalletPortfolio/DashboardWalletPortfolio.module.css"],"names":[],"mappings":"AAGA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,mDAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;;IAEhB,aAAa;IACb,mBAAmB;;IAEnB,yBAAyB;IACzB,kBAAkB;;IAElB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,0DAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mDAAwB;IACxB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;;IAEnB,YAAY;IACZ,eAAe;;IAEf,eAAe;AACnB;;AAEA;IACI,8DAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA,wBAAU,gBAAgB,EAAE;AAC5B,wBAAW,mDAAwB,EAAE;;AAErC;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mDAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["@value colors: \"../../../../components/library/style/colors.css\";\n@value color-purple, color-purple-bg, color-text-subtle from colors;\n\n.logo {\n    width: 42px;\n    height: 42px;\n    border-radius: 42px;\n    object-fit: cover;\n}\n\n.header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    padding: 16px;\n}\n\n.search {\n    color: color-text-subtle;\n    transition: .3s;\n}\n\n.search:hover {\n    color: rgba(0,0,0,0.8);\n}\n\n.searchbar {\n    width: 100%;\n    min-height: 32px;\n\n    display: flex;\n    align-items: center;\n\n    border: 1px solid #E5E5E5;\n    border-radius: 5px;\n\n    margin-top: 8px;\n    padding-left: 4px;\n}\n\n.searchbar:hover {\n    border-color: color-purple;\n}\n\n.searchbar input {\n    width: 90%;\n    height: 100%;\n    border: none;\n    outline: none;\n}\n\n.clear {\n    display: flex;\n    align-items: center;\n    color: color-text-subtle;\n    font-size: 14px;\n    transition: .3s;\n}\n\n.clear:hover {\n    color: rgba(0,0,0,0.8);\n}\n\n.title {\n    font-size: 18px;\n    margin: 0;\n}\n\n.investment {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n    height: 64px;\n    padding: 0 16px;\n\n    transition: .3s;\n}\n\n.investment:hover {\n    background-color: color-purple-bg;\n    cursor: pointer;\n}\n\n.shares, .balance {\n    margin: 0;\n    text-align: right;\n}\n\n.shares { font-weight: 500; }\n.balance { color: color-text-subtle; }\n\n.empty {\n    font-size: 18px;\n    font-weight: 500;\n    padding: 0 16px;\n    text-align: center;\n    color: color-text-subtle;\n}\n\n.logoPlaceholder {\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../../components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"logo": `DQyqvwDnrY8AY34j0VtO`,
	"header": `iVJP_pBDy9Bpboeg7811`,
	"search": `TJm8QjsyxHIXzz_Y8vRV`,
	"searchbar": `WV7jsdjR_d7AGX7fvg3s`,
	"clear": `SB1pKVYF7kUthf9JTZhN`,
	"title": `pcKaQJnYbDUccGU6zM3M`,
	"investment": `DHIhkkHQXI5cY7kP28v9`,
	"shares": `qGJ9SxjDNgQXOc4NmZ9F`,
	"balance": `XaDIGlNhQuyV_TpQeNPm`,
	"empty": `pgKU6qGd9K_MAs0uwbcd`,
	"logoPlaceholder": `hSicMw3qjMrp_JTtKgET`
};
export default ___CSS_LOADER_EXPORT___;
